module.exports = __webpack_public_path__ + "img/1.7.2-3.ef0ecfdd.jpg";